import {makeStyles} from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import {Typography} from "@material-ui/core";
import React, {useState} from "react";
import UseDeviceSettings from "./hooks/UseDeviceSettings";
import Loading from "../common/Loading";
import Button from "@material-ui/core/Button";
import {validationError, validationSuccess} from "../../helpers/ValidationHelper";
import DeviceTransport from "./DeviceTransport";
import DeviceMetadata from "./DeviceMetadata";
import DeviceSettingsBlock from "./DeviceSettingsBlock";
import CloseIcon from '@material-ui/icons/Close';
import IconButton from "@material-ui/core/IconButton";

const useStyles = makeStyles(theme => ({
    root: {},
    grid: {
        padding: theme.spacing(2),
    }
}));

export default function DeviceSettings({deviceId, width, onClose}) {
    const classes = useStyles();

    const [applying, setApplying] = useState(false);
    const [validationErrors, setValidationErrors] = useState({});

    const hasErrors = !!Object.keys(validationErrors).length;

    const {
        device,
        deviceLoading,
        handleSettingsChanged,
        handleMetadataChanged,
        handleSettingsApply
    } = UseDeviceSettings({deviceId});

    if (deviceLoading || !device) {
        return <Loading/>;
    }

    function handleValidationSuccess(type) {
        setValidationErrors(validationSuccess(type, validationErrors));
    }

    function handleValidationError(type) {
        setValidationErrors(validationError(type, validationErrors));
    }

    const {id, title, vendor, protocol, settings, metadata} = device;

    return (
        <div className={classes.root}>
            <Grid container
                  spacing={2}
                  direction={"column"}
                  justify={"space-between"}
                  alignItems={"center"}
                  className={classes.grid}
                  style={{width: width}}
            >
                <Grid item xs={12} container justify={"space-around"} alignItems={"center"}>
                    <Grid item xs={2}>
                        <IconButton aria-label="close" disableRipple onClick={onClose} size={"small"}>
                            <CloseIcon/>
                        </IconButton>
                    </Grid>
                    <Grid item xs={8}>
                        <Typography align={"center"} noWrap>{title}</Typography>
                    </Grid>
                    <Grid item xs={2}/>
                </Grid>
                <DeviceSettingsBlock title={"Transport"} children={
                    DeviceTransport({
                        deviceId: id,
                        protocol: protocol,
                        settings: settings,
                        onChange: handleSettingsChanged,
                        onValidationSuccess: () => handleValidationSuccess("TRANSPORT"),
                        onValidationError: () => handleValidationError("TRANSPORT")
                    })
                }/>
                <DeviceSettingsBlock title={"Metadata"} children={DeviceMetadata({
                    vendor: vendor,
                    metadata: metadata,
                    onChange: handleMetadataChanged,
                    onValidationSuccess: () => handleValidationSuccess("METADATA"),
                    onValidationError: () => handleValidationError("METADATA")
                })}
                />
                <Grid item xs={12}>
                    <Button size="small"
                            variant="contained"
                            color="primary"
                            disabled={applying || hasErrors}
                            onClick={() => {
                                if (hasErrors) return;

                                setApplying(true);

                                handleSettingsApply().finally(() => setApplying(false));
                            }}
                    >
                        Apply
                    </Button>
                </Grid>
            </Grid>
        </div>
    );
}